import React from 'react';
import IUCNLogo from 'src/assets/images/dashboard/iucn.png';
import Loader from 'src/shared/components/loader/Loader';
import MetricCard from 'src/shared/components/metric-card/MetricCard';
import QuestionButtonHelp from 'src/shared/components/question-button-help/QuestionButtonHelp';
import { useSpeciesMetricsQuery } from 'src/app/dashboard/state/metrics/metricsGraphSlice';
import { filterByRedListStatus } from 'src/app/dashboard/components/metrics/metrics-table/metricsTableHelpers';
import useProjectFilters from 'src/shared/hooks/useProjectFilters';

const IucnMetrics = () => {
    const {
        currentProjectId,
        currentProjectSelectedHabitatAssayType: habitatAssayType,
        currentProjectSelectedDateRange,
    } = useProjectFilters();

    const { currentData, isFetching } = useSpeciesMetricsQuery(
        {
            projectId: currentProjectId || '',
            samples: {
                fromDate: currentProjectSelectedDateRange?.startDate,
                toDate: currentProjectSelectedDateRange?.endDate,
                habitatAssay: habitatAssayType?.key || '',
            },
        },
        {
            skip: !currentProjectId || !habitatAssayType || !currentProjectSelectedDateRange,
        }
    );

    if (!currentData || isFetching) {
        return <Loader />;
    }

    const { speciesMetrics: speciesMetricsData } = currentData;
    const { taxonomySummary } = speciesMetricsData;

    const iucnRedLists = filterByRedListStatus(taxonomySummary);

    return (
        <MetricCard
            header='IUCN Red List'
            content='Red List species detected'
            helpText={<QuestionButtonHelp type='api' placement='right' slug='iucn-status' />}
            total={iucnRedLists.length}
            logo={<img src={IUCNLogo} alt='Logo' style={{ marginRight: '5px' }} />}
        />
    );
};

export default IucnMetrics;
